import { clone } from '../../helpers/';
import types from '../types';

export interface ISaveAsState {
    journeyTitle: string;
}

export const initialState: ISaveAsState = {
    journeyTitle: ''
};

const saveAsReducer = function(state:ISaveAsState = initialState, action): ISaveAsState {

	let stateClone:ISaveAsState = clone(state);

    switch(action.type) {
		case types.SAVE_AS_JOURNEY_TITLE_CHANGE:
			updateJourneyTitle(stateClone, action.journeyTitle);
			break;
		default:
			break;
	}

	return stateClone;

};

let updateJourneyTitle = (state: ISaveAsState, journeyTitle: string): ISaveAsState => {
	
	state.journeyTitle = journeyTitle;
	return state;
};

export default saveAsReducer;


// WEBPACK FOOTER //
// ./source/ts/store/reducers/save-as.ts